import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import AttendanceListTab from '../../modules/attendance/AttendanceListTab';
import AttendanceDetailTab from '../../modules/attendance/AttendanceDetailTab';
import AttendanceOpenEventTab from '../../modules/attendance/AttendanceOpenEventTab';


const Attendance = (props) => {

    const [activeTab, setActiveTab] = useState('LIST');
    const [selectedRecord, setSelectedRecord] = useState();
    const [t] = useTranslation();

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const handleCallback = (id,action) => {
        switch(action){            
             case 'DETAIL':
                setSelectedRecord(id);
                setActiveTab('DETAIL');                
             break;
             case 'OPEN_EVENT':
                setSelectedRecord(id);
                setActiveTab('OPEN_EVENT');                
             break;
             default:
        }
    };

    return (
        <>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>{t('attendance.label.attendance')}</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/">{t('menusidebar.label.team')}</Link>
                                </li>
                                <li className="breadcrumb-item active">
                                    {t('attendance.label.attendance')}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className="row"></div>
                            <div className="col-12 col-sm-12 col-lg-12" style={{margin: '0 auto',float: 'none'}}>
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" role="tablist">
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'LIST'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('LIST')
                                                    }
                                                >
                                                    {t('attendance.label.list')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'DETAIL'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('DETAIL')
                                                    }
                                                >
                                                    {t('attendance.label.detail')}
                                                </button>
                                            </li>                                          
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'OPEN_EVENT'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('OPEN_EVENT')
                                                    }
                                                >
                                                    {t('attendance.label.openEvents')}
                                                </button>
                                            </li>   
                                         </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content">
                                            <AttendanceListTab
                                                isActive={activeTab === 'LIST'}
                                                parentCallback={handleCallback}    
                                            />                                                                                                                              
                                             <AttendanceDetailTab
                                                isActive={activeTab === 'DETAIL'}
                                                selectedRecord={selectedRecord}
                                            />  
                                             <AttendanceOpenEventTab
                                                isActive={activeTab === 'OPEN_EVENT'}                                                
                                            />  
                                             
                                        </div>
                                    </div>
                                </div>   
                            </div>                         
                </div>
            </section>
        </>
    );
};

export default Attendance;